// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__16wmh","head":"ProcedureTableInfo_head__DpwOT"};